import { useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import Swal from "sweetalert2";
import { ClosingRateService } from "../../services/ClosingRateService";
import * as BullCache from "../../util/BullCache";
import MarketDropdown from "../components/MarketDropdown";
import ScriptDropdown from "../components/ScriptDropdown";
import moment from 'moment';

function AddClosingRate() {

    const [selectedMarket, setSelectedMarket] = useState('');
    const [selectedScript, setSelectedScript] = useState('');
    const [closingRate, setClosingRate] = useState('');
    const [expiryDate, setExpiryDate] = useState('');

    var user = BullCache.getFromCache("user");
    var allScripts = BullCache.getFromCache('allScripts');

    const handleMarketChange = (market) => {
        setSelectedMarket(market);
    };
    const handleScriptReset = () => {
        setSelectedScript(null);
    };
    const handleScriptChange = (script) => {
        setSelectedScript(script);
    };

    const handleClosingRateChange = (e) => {
        setClosingRate(e.target.value);
    };

    const handleExpiryDateChange = (e) => {
        setExpiryDate(e.target.value);
    };

    const handleSubmit = () => {

        const formattedDate = moment(expiryDate).format('DD/MM/YYYY');

        const selectedData = {
            adminId: user.adminId,
            segment: selectedMarket,
            script: selectedScript,
            rate: closingRate,
            expiryDate: formattedDate
        };
        ClosingRateService.AddClosingRate(selectedData).then(res => {
            if (res.code === 1) {
                Swal.fire({
                    icon: "success",
                    text: "Added Successfully!!.."
                });
                setSelectedMarket('');
                setSelectedScript('');
                setClosingRate('');
                setExpiryDate('');
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                });
            }
        });
    };

    return (
        <Card className="mt-2">
            <Card.Body>
                <Row className='mt-3'>
                    <Col sm={4}>
                        <b className='fss-05'>MARKET</b>
                        <MarketDropdown
                            allScripts={allScripts}
                            onMarketChange={handleMarketChange}
                            selectedMarket={selectedMarket}
                            onScriptReset={handleScriptReset}
                        />
                    </Col>

                    <Col sm={4}>
                        <b className='fss-05'>SCRIPT NAME</b>
                        <ScriptDropdown
                            allScripts={allScripts}
                            selectedMarket={selectedMarket}
                            onScriptChange={handleScriptChange}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        <b className=' fss-05' >CLOSING RATE</b>
                        <Form.Control type='number' className='bg-light text-black' size="sm"
                            value={closingRate}
                            onChange={handleClosingRateChange}
                        />
                    </Col>

                    <Col className="col-4">
                        <b className="fss-05">EXPIRY DATE:</b>
                        <Form.Control
                            type="date"
                            className="bg-light text-black"
                            size="sm"
                            value={expiryDate}
                            onChange={handleExpiryDateChange}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col sm={3} className="me-3"></Col>
                    <Col className="mt-4" sm={6}>
                        <Button variant="success" size="sm w-25" onClick={handleSubmit}>Submit</Button>
                    </Col>
                </Row>

            </Card.Body>
        </Card>

    );
}
export default AddClosingRate;